import CodeRadio from './Index.vue'

CodeRadio.install = function(Vue) {
  Vue.component(CodeRadio.name, CodeRadio)
}

export default CodeRadio
